import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: JSON.parse(localStorage.getItem("userData")) || null,
  accessToken: localStorage.getItem("tokens") || null,
  refreshtoken: localStorage.getItem("refreshtoken") || null,
  googleState: null,
  userProfile: JSON.parse(localStorage.getItem("user-profile")) || null,
  currencySymbol: JSON.parse(localStorage.getItem("userCurrency")) || {
    symbol: "د.إ",
    code: "",
    country: "",
    currency: "AED",
  },
  userDetails: [],
  isSubmit: false,
  bidsdata: [],
  urlPath: null,
  isedit: false,
  addCard: false,
  likes: [],
  resetTokens: false,
  isRefreshingToken: false,
  xpLeaderboard: [],
  soldLeaderboard: [],
  boughtLeaderboard: [],
  dailySoldLeaderboard: [],
  address_data: [],
  homeAuctionsList: [],
  stripe_data: null,
  is_first: false,
  categories: [],
  ask: "",
  buy: "",
  sellNowData: {
    selectedAskOption: "sellnow",
    customAskAmount: "",
    expiration: "",
  },
};

const userSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    addCategories: (state, action) => {
      state.categories = action.payload;
    },
    changeAsk: (state, action) => {
      state.ask = action.payload;
    },
    changeBuy: (state, action) => {
      state.buy = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshtoken = null;
      state.userProfile = [];
      state.userDetails = [];
    },
    startTokenRefresh: (state) => {
      state.isRefreshingToken = true;
    },
    stopTokenRefresh: (state) => {
      state.isRefreshingToken = false;
    },
    resetRefreshToken: (state, action) => {
      state.refreshtoken = action.payload;
    },
    updateUserToken: (state, action) => {
      state.accessToken = action.payload;
    },
    resetTokens: (state, action) => {
      state.resetTokens = action.payload;
    },
    getProfileData: (state, action) => {
      state.userProfile = action.payload;
    },
    getCurrencySymbol: (state, action) => {
      state.currencySymbol = action.payload;
    },
    getHomeAuctions: (state, action) => {
      state.homeAuctionsList = action.payload;
    },
    getAllMyAddress: (state, action) => {
      state.address_data = action.payload;
    },
    userUpdate: (state, action) => {
      state.user = action.payload;
    },
    getUserProfile: (state, action) => {
      state.userDetails = action.payload;
    },
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload;
    },
    getUserBidsInfo: (state, action) => {
      state.bidsdata = action.payload;
      state.totalbidWons = action.payload.bidWons;
    },
    setUserSocialSignin: (state, action) => {
      state.googleState = action.payload;
    },
    getUrlPath: (state, action) => {
      state.urlPath = action.payload;
    },
    setIsEdit: (state, action) => {
      state.isedit = action.payload;
    },
    setUserAddCard: (state, action) => {
      state.addCard = action.payload;
    },
    getStripeAccountData: (state, action) => {
      state.stripe_data = action.payload;
    },
    getFirstLogin: (state, action) => {
      state.is_first = action.payload;
    },
    getCommentLikes: (state, action) => {
      state.likes = action.payload;
    },
    setXpLeaderboard: (state, action) => {
      state.xpLeaderboard = action.payload;
    },
    setSoldLeaderboard: (state, action) => {
      state.soldLeaderboard = action.payload;
    },
    setBoughtLeaderboard: (state, action) => {
      state.boughtLeaderboard = action.payload;
    },
    setDailySoldLeaderboard: (state, action) => {
      state.dailySoldLeaderboard = action.payload;
    },
    setSellNowData: (state, action) => {
      state.sellNowData = {
        ...state.sellNowData,
        ...action.payload,
      };
    },

    resetSellNowData: (state) => {
      state.sellNowData = initialState.sellNowData;
    },
  },
});

export const {
  addCategories,
  changeAsk,
  changeBuy,
  logout,
  startTokenRefresh,
  stopTokenRefresh,
  resetRefreshToken,
  updateUserToken,
  resetTokens,
  getProfileData,
  getHomeAuctions,
  getAllMyAddress,
  userUpdate,
  getUserProfile,
  getCurrencySymbol,
  setIsSubmit,
  getUserBidsInfo,
  setUserSocialSignin,
  getUrlPath,
  setIsEdit,
  setUserAddCard,
  getStripeAccountData,
  getFirstLogin,
  getCommentLikes,
  setXpLeaderboard,
  setSoldLeaderboard,
  setBoughtLeaderboard,
  setDailySoldLeaderboard,
  setSellNowData,
  resetSellNowData,
} = userSlice.actions;
export default userSlice.reducer;